const obj = {
  ...require('./modules/decoration.js').default,
  ...require('./modules/order.js').default,
  ...require('./modules/material.js').default,
  ...require('./modules/coupon.js').default,
  ...require('./modules/reduction-postage.js').default,
  ...require('./modules/seller.js').default,
  ...require('./modules/faq.js').default,
  ...require('./modules/goods.js').default,
  ...require('./modules/sec-send.js').default,
};

// freeze不太行 需要有error, 考虑用proxy
// function deepFreeze(o) {
//   Object.freeze(o);
//   if (o === undefined) {
//     return o;
//   }

//   Object.getOwnPropertyNames(o).forEach(function(prop) {
//     if (
//       o[prop] !== null &&
//       (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
//       !Object.isFrozen(o[prop])
//     ) {
//       deepFreeze(o[prop]);
//     }
//   });

//   return o;
// }
export default obj;
